/**
 * Module: `sources/source-categories.ts` — SSOT for source category order and labels
 * (chat accordion + export de réponse).
 */

import type { SourceType } from "@/types";

/** Display order identical to the chat Sources documentaires accordion. */
export const SOURCE_TYPE_ORDER: readonly SourceType[] = [
  "sidoni",
  "legifrance",
  "anc",
  "h2a",
  "macncc",
  "cncc",
  "formation",
] as const;

/** Chat accordion section titles — reused by PDF / Word / clipboard. */
export const SOURCE_CATEGORY_LABELS: Record<SourceType, string> = {
  sidoni: "Sources Sidoni publiées",
  legifrance: "Sources Légifrance",
  anc: "Sources ANC",
  h2a: "Sources H2A",
  macncc: "Ma CNCC",
  cncc: "Autres sources CNCC",
  formation: "Formations CNCC",
};

export const SOURCES_DOCUMENTAIRES_HEADING = "Sources documentaires";
